// Copyright (c) 2020-23, iPivot, Corp.
'use strict'

import React from 'react';
import { createRoot } from 'react-dom/client'
import i18next from 'i18next'
import LngDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'
import { Suspense } from 'react'
import { Spinner } from 'react-bootstrap'
import { initReactI18next } from 'react-i18next'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'

import LoginRoutes from 'js/routes/LoginRoutes'

import 'bootstrap/dist/css/bootstrap.min.css'
import { GlobalStyles } from 'js/themes/GlobalStyles'
import { useTheme } from 'js/themes/useTheme'

i18next
    .use(LngDetector)
    .use(Backend)
    .use(initReactI18next)
    .init({
        backend: {
            loadPath: '/dist/locales/{{lng}}/{{ns}}.json',
        },
        detection: {
            order: ['navigator'],
        },
        fallbackLng: 'en',
        load: 'languageOnly',
        interpolation: {
            escapeValue: false, // not needed for react
        },
    })

const LoginApp = () => {
    const theme = useTheme()

    if (Object.keys(theme).length > 0) {
        return (
            <Router basename="/login">
                <Suspense
                    fallback={
                        <div className="d-flex align-items-center">
                            <Spinner />
                            <span className="ms-2">Loading</span>
                        </div>
                    }
                >
                    <ThemeProvider theme={theme}>
                        <GlobalStyles />
                        <Routes>
                            <Route path="/*" element={<LoginRoutes />} />
                        </Routes>
                    </ThemeProvider>
                </Suspense>
            </Router>
        )
    } else {
        return (
            <div className="d-flex align-items-center">
                <Spinner />
                <span className="ms-2">Loading</span>
            </div>
        )
    }
}

const loginMountNode = document.getElementById('enc')
if (loginMountNode) {
    const loginRoot = loginMountNode.__ipivotReactRoot || createRoot(loginMountNode)
    loginMountNode.__ipivotReactRoot = loginRoot
    loginRoot.render(<LoginApp />)
}
